import { getHashOrQueryParam } from '../window/WindowUtils';

const getDeviceId = () => {
  return getHashOrQueryParam('device') || 'N/A';
};

export { getDeviceId };
